import React, { useState } from "react";
import './style.css';
const Header = () => {
    return (
        <div className="header">
            <h4>My Todo List</h4>
        </div>
    )
}

export default Header;